/*const stockendpoint = 'http://localhost/crecepymes-stock-endpoint/?local=true'*/
const stockendpoint = 'http://crecepymes.com/stock-endpoint/index.php'

export default stockendpoint
